export default __webpack_public_path__ + "static/media/notfound.30539eef.gif";